import styled from '@emotion/styled';
import { CommonWrapper } from 'screens/AgentOfficePages/styled';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';
import { Text, TextLabel, SmallText } from 'ds/components/typography';


export const Root = styled(CommonWrapper)<{ isMobile: boolean }>(({ isMobile }) => ({
  overflow: isMobile ? 'visible' : 'hidden',
}));

export const Card = styled.div<{ isMobile: boolean }>(({ theme, isMobile }) => ({
  position: 'relative',
  padding: theme.spacing(isMobile ? 2 : 4),
  marginBottom: isMobile ? 0 : theme.spacing(4),
  borderRadius: theme.borderRadius.small,
  border: `1px solid ${theme.colors.brand.lightest}`,
  background: `linear-gradient(0deg, rgba(203, 240, 242, 0.10) 0%, rgba(203, 240, 242, 0.10) 100%), #FFF`,
  '.hood-icon': {
    display: isMobile ? 'none' : 'block',
    position: 'absolute',
    left: 0,
    bottom: 0,
    borderBottomLeftRadius: theme.borderRadius.small,
  },
}));

export const TitleIconWrapper = styled.div<{ isMobile: boolean }>(({ isMobile }) => isMobile ? ({
  position: 'absolute',
  top: '-15px',
  left: '9px',
}) : ({
  maxHeight: '42px',
  overflow: 'hidden',
  'svg': {
    transform: 'translateY(-5px)',
  },
}));

export const CardInner = styled.div<{ isMobile: boolean }>(({ theme, isMobile }) => ({
  display: 'flex',
  gap: isMobile ? 0 : theme.spacing(2),
  flexDirection: 'column',
  maxWidth: '670px',
}));

export const HoodsSection = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
  flexDirection: 'column',
}));

export const HoodList = styled.div(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

export const HoodItem = styled(TextLabel)(({ theme }) => ({
  padding: theme.spacing(0.25, 1),
  minHeight: '28px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.colors.neutrals.grey10,
  border: `1px solid ${theme.colors.neutrals.grey8}`,
  borderRadius: theme.borderRadius.tiny,
  color: theme.colors.neutrals.grey1,
}));

export const HoodTitle = styled(SmallText)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));


export const Statement = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey3,
  whiteSpace: 'pre-wrap',
}));

export const MobileStatement = styled(TextLabel)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
  color: theme.colors.neutrals.grey3,
  whiteSpace: 'pre-wrap',
}));

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.brand.lighter};
  font-size: ${typographyFontSizeCfg.h3.mobile}px;
  line-height: ${typographyLineHeightCfg.h3.mobile}px;
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    font-size: ${typographyFontSizeCfg.h2.mobile}px;
    line-height: ${typographyLineHeightCfg.h2.mobile}px;
  `}
  svg {
    display: block;
  }
`;
